"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authConfiguration = void 0;
exports.authConfiguration = [
    {
        cognitoConfigIdentifier: 'default',
        cognitoConfig: {
            cognitoUserPoolId: 'ap-southeast-2_NhWKfP0M3',
            cognitoUserPoolWebClientId: '2c6ugu05q5msqrmtc3vne2gg6l',
            cognitoRegion: 'ap-southeast-2',
        },
    },
    {
        cognitoConfigIdentifier: 'CDFpay',
        cognitoConfig: {
            cognitoUserPoolId: 'ap-southeast-2_QgAwQ3IBB',
            cognitoUserPoolWebClientId: '39l656357384haffe332pc44en',
            cognitoRegion: 'ap-southeast-2',
        },
    },
];
//# sourceMappingURL=AuthConfig.js.map